import * as THREE from 'three';
import { Draw3d } from "../../graphicLibs/index";
import { PointInfo } from "../../WalltoFittingInfo";
import * as marietta from '../../../';

type HalfGridType = { index: number[], point: THREE.Vector3 };

/**
 * モジュールピッチ補正
 * */
export class HalfPitchGrid {

    private pitch = 455;
    private unit = this.pitch / 2 / 1000;
    private halfUnit = this.unit / 2;
    private gridList: PointInfo[];
    private box: THREE.Box3; 

    constructor(private pointList: PointInfo[]) {
        this.gridList = [];
        const points = pointList.map((info: PointInfo) => info.point);
        this.box = new THREE.Box3().setFromPoints(points);
    } 

    // gridとpointListとの関係性の構築
    public execute(): PointInfo[] {

        const lengthX = Math.floor((this.box.max.x - this.box.min.x) / this.unit) + 1;
        const lengthZ = Math.floor((this.box.max.z - this.box.min.z) / this.unit) + 1;
        // grid分配列用意
        const gridPointList: HalfGridType[] = new Array(lengthX * lengthZ);
        console.log(gridPointList.length);

        // const gridList_: PointInfo[] = [];
        
        for (let i = 0; i < this.pointList.length; i++) {
            const point = this.pointList[i].point;

            let vertical = Math.floor(point.clone().sub(this.box.min).x / this.unit);
            if (this.unit * vertical + this.box.min.x + this.halfUnit < point.x) vertical += 1;

            let horizontal = Math.floor(point.clone().sub(this.box.min).z / this.unit);
            if (this.unit * horizontal + this.box.min.z + this.halfUnit < point.z) horizontal += 1;
            console.log(vertical + horizontal * lengthX);
            
            const x = vertical * this.unit + this.box.min.x;
            const z = horizontal * this.unit + this.box.min.z;
            if (gridPointList[vertical + horizontal * lengthX] == null) {
                gridPointList[vertical + horizontal * lengthX] = { index: [i], point: new THREE.Vector3(x, 0, z) };
            } else {
                gridPointList[vertical + horizontal * lengthX].index.push(i);
            }
            this.gridList[i] = new PointInfo(new THREE.Vector3(x, 0, z), true, this.pointList[i].isDelete);
        }

        return this.gridList;

    }

    // 
    // public length(pitch: number, divide: number) {
    //     this.pitch = pitch;
    //     this.unit = pitch / divide / 1000; 
    //     this.halfUnit = this.unit / 2;
    // }
    
    /** 
     * しきい値設定 
     * */
    public length(divide: number) {
        this.unit = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch * divide / 1000;
        this.halfUnit = this.unit / 2;
    }

    public draw() {
        // grid描画
        Draw3d.drawGrid(this.box, this.unit);
        // 壁描画
        for (let i = 0; i < this.gridList.length; i+=2) {
            const dir = this.gridList[i+1].point.clone().sub(this.gridList[i].point);
            Draw3d.drawArrowHelper(this.gridList[i].point, dir, 0xFFD700);
        }
    }

}